/* eslint-disable prettier/prettier */
import React, {
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { useRouteMatch } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';
import { FiPlusCircle } from 'react-icons/fi';
import { usePerfil } from '../../hooks/perfil';
import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';

import Input from '../Input';
import SelectSync, { IOption } from '../SelectSync';
import InputMoney from '../InputMoney';
import getValidationErrors from '../../utils/getValidationErrors';
import InputFake from '../InputFake';
import Toggle from '../Exame/Toggle';

import {
  IProcedimento,
  IValoresProcedimento,
  useProcedimento,
} from '../../hooks/procedimentos';

import { useClinica } from '../../hooks/clinica';
import { formatPrice } from '../../utils/funcoes';
import AddValor from './AddValor';
import LinhaValor from './Linha';

interface IUrlParams {
  id: string;
}

type Props = {
  procedimento?: IProcedimento;
  setShowModal(values: boolean): void;
  // addProcedimento(
  //   dadosProcedimento: IProcedimento,
  //   perf?: IOption,
  //   proCodigo?: number,
  // ): Promise<boolean>;
};

const ProcedimentoCadastroPagina: React.FC<Props> = ({
  procedimento,
  setShowModal,
}) => {
  const { optionsPerfil, perfis, buscaPerfil } = usePerfil();
  const { addToast } = useToast();
  const { buscaConvenios, optionsConvenio } = useClinica();
  const { clinica, user } = useAuth();
  const { addProcedimento } = useProcedimento();
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;
  const [proCodigo, setProCodigo] = useState<number | undefined>(
    id ? Number(id) : undefined,
  );
  const [loading, setLoading] = useState(false);
  const [nomePerfil, setNomePerfil] = useState('');
  const formRefProcedimento = useRef<FormHandles>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [optionsPerfis, _] = useState<IOption[]>(optionsPerfil.optionPerfis);
  const [perfilSelecionado, setPerfilSelecionado] = useState<
    number | undefined
  >(undefined);

  const [showAddValor, setShowAddValor] = useState(false);
  const [procedimentoValor, setProcedimentoValor] = useState<
    IValoresProcedimento[]
  >();

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);

  const CliSaoPaulo = useMemo(() => {
    return clinica.CliDrSaude === false;
  }, [clinica.CliDrSaude]);

  const ehExame = useMemo(() => {
    if (procedimento)
      return perfis.perfis.find(
        p =>
          p.PerIntegracao === true && p.PerCodigo === procedimento.ProPerCodigo,
      );

    if (perfilSelecionado)
      return perfis.perfis.find(
        p => p.PerIntegracao === true && p.PerCodigo === perfilSelecionado,
      );

    return false;
  }, [perfis, perfilSelecionado, procedimento]);

  useEffect(() => {
    async function Busca(): Promise<void> {
      await buscaConvenios();
    }
    if (
      clinica.CliAtendeConvenio &&
      (!optionsConvenio || optionsConvenio.length === 0)
    )
      Busca();
  }, [buscaConvenios, optionsConvenio, clinica.CliAtendeConvenio]);

  useEffect(() => {
    if (procedimento) {
      setProCodigo(procedimento.ProCodigo);
      if (proCodigo) {
        const perf = optionsPerfis.find(
          per => per.value === procedimento.ProPerCodigo?.toString(),
        );

        if (perf) setNomePerfil(perf.label);
      }
      setProcedimentoValor(procedimento.valoresProcedimentoConvenio || []);
    }
  }, [procedimento, optionsPerfis, proCodigo]);

  const ehNovo = useMemo(() => {
    return !proCodigo || proCodigo === 0;
  }, [proCodigo]);

  const validaPerfil = useMemo(() => {
    if (ehNovo)
      return {
        ProPerCodigo: Yup.number()
          .integer('Perfil obrigatório')
          .typeError('Perfil obrigatório')
          .required('Perfil obrigatório'),
      };
    return {};
  }, [ehNovo]);

  const validaCodigoAlvaro = useMemo(() => {
    if (ehExame)
      return {
        ProCodigoAlvaro: Yup.string().required('Código Alvaro obrigatório'),
      };
    return {};
  }, [ehExame]);

  const handleSubmitProcedimento = useCallback(
    async (dados: IProcedimento) => {
      setLoading(true);
      try {
        let adic = {};
        const ativo = dados.ProAtivo ? dados.ProAtivo.toString() : 'false';
        const online = dados.ProOnline ? dados.ProOnline.toString() : 'false';
        const telemedicina = dados.ProTelemedicina ? dados.ProTelemedicina.toString() : 'false';


        adic = {
          ...adic,
          ...validaPerfil,
          ...(ativo === 'true' ? validaCodigoAlvaro : {}),
        };

        formRefProcedimento.current?.setErrors({});
        const schema = Yup.object().shape({
          ProNome: Yup.string()
            .min(3, 'Mínimo 3 caracteres')
            .required('Nome é obrigatório'),
          ProValor: Yup.number().required(),
          ProDuracao: Yup.number().required(),
          ProRetorno: Yup.number().required(),
          ProLimite: Yup.number().required(),
          ProValorPlano: Yup.number().required(),
          ProCarencia: Yup.number().required(),
          ProValorPlano2: Yup.number().required(),
          ...(CliSaoPaulo && {
            ProValorPlanoEmpresarial: Yup.number().required(),
          }),
          ...adic,
        });

        const procedimentoForm = {
          ...dados,
          ...(!CliSaoPaulo && { ProValorPlanoEmpresarial: 0 }),
        };

        await schema.validate(procedimentoForm, {
          abortEarly: false,
        });

        if (
          Number(procedimentoForm.ProValorPlano2) <
          Number(procedimentoForm.ProValorPlano)
        ) {
          formRefProcedimento.current?.setFieldError(
            'ProValorPlano2',
            'Valor fora da carência não pode ser menor que valor cartão saúde',
          );
          throw new Error(
            'Valor fora da carência não pode ser menor que valor cartão saúde',
          );
        }

        if (
          CliSaoPaulo &&
          Number(procedimentoForm.ProValorPlanoEmpresarial) <
          Number(procedimentoForm.ProValorPlano)
        ) {
          formRefProcedimento.current?.setFieldError(
            'ProValorPlanoEmpresarial',
            'Valor empresa não pode ser menor que valor cartão saúde',
          );
          throw new Error(
            'Valor empresa não pode ser menor que valor cartão saúde',
          );
        }

        const perfCodigo = procedimento
          ? procedimento.ProPerCodigo
          : perfilSelecionado;
        const perf = optionsPerfis.find(
          per => per.value === perfCodigo?.toString(),
        );
        let adicionou = false;
        if (ehNovo) {
          adicionou = await addProcedimento(
            {
              ...procedimentoForm,
              ProNome: dados.ProNome.toUpperCase(),
              ProAtivo: ativo === 'true',
              ProFavorito: false,
              ...(clinica.CliTelemedicina && user.UsuCodigo === 1 ? {
                ProOnline: online === 'true',
                ProTelemedicina: telemedicina === 'true',
              } : {}),
            },
            perf,
          );
        } else {
          adicionou = await addProcedimento(
            {
              ...procedimentoForm,
              ProNome: dados.ProNome.toUpperCase(),
              ProAtivo: ativo === 'true',
              ProFavorito: false,
              ProPerCodigo: undefined,
              ...(clinica.CliTelemedicina && user.UsuCodigo === 1 ? {
                ProOnline: online === 'true',
                ProTelemedicina: telemedicina === 'true',
              } : {}),
            },
            perf,
            proCodigo,
          );
        }
        setShowModal(!adicionou);
      } catch (error: any) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefProcedimento.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao salvar procedimento',
          description: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      addToast,
      proCodigo,
      optionsPerfis,
      procedimento,
      ehNovo,
      validaCodigoAlvaro,
      validaPerfil,
      addProcedimento,
      perfilSelecionado,
      CliSaoPaulo,
      setShowModal,
      clinica.CliTelemedicina,
      user.UsuCodigo,
    ],
  );

  const handleOnChange = useCallback((dados: IOption) => {
    setPerfilSelecionado(Number(dados.value));
  }, []);

  const handleFormataValoresConvenio = useCallback(
    (dados: IValoresProcedimento[]) => {
      const procedimentoValorFormatado = dados.map(val => {
        return {
          ...val,
          convenio:
            optionsConvenio.find(
              conv => conv.value === val.ConvCodigo.toString(),
            )?.label || 'ND',
          valorFormatado: formatPrice(val.valor),
        };
      });
      return procedimentoValorFormatado;
    },
    [optionsConvenio],
  );

  const handleSalvouNovoValor = useCallback(
    (dados: IValoresProcedimento) => {
      const valorAdicionado = handleFormataValoresConvenio([dados]);
      setProcedimentoValor(state => {
        const valoresCadastrados = state?.filter(
          conv => conv.ConvCodigo !== valorAdicionado[0].ConvCodigo,
        );

        if (valoresCadastrados) {
          const valoresAtualizados = valoresCadastrados.concat(valorAdicionado);
          return valoresAtualizados;
        }

        return valorAdicionado;
      });
      setShowAddValor(false);
    },
    [handleFormataValoresConvenio],
  );

  const handleDeletouConvenioValor = useCallback((ConvCodigo: number) => {
    setProcedimentoValor(state => {
      return state
        ? state.filter(conv => conv.ConvCodigo !== ConvCodigo)
        : undefined;
    });
  }, []);

  return (
    <div className="container">
      <Row noGutters>
        <Col md={12}>
          <Form
            ref={formRefProcedimento}
            initialData={procedimento}
            onSubmit={handleSubmitProcedimento}
          >
            <Row>
              <Col
                md={12}
                className={`form-group pr-2 ${proCodigo ? 'd-none' : ''}`}
              >
                <SelectSync
                  name="ProPerCodigo"
                  label="Perfil"
                  placeholder="Selecione"
                  handleSelectChange={handleOnChange}
                  options={optionsPerfis}
                />
              </Col>
              <Col
                md="12"
                lg="12"
                className={`form-group pr-2 ${proCodigo ? '' : 'd-none'}`}
              >
                <InputFake label="Perfil" disabled value={nomePerfil} />
              </Col>
            </Row>
            <Row>
              <Col md={ehExame ? 8 : 12} className="form-group pr-2">
                <Input name="ProNome" label="Nome" maxLength={100} />
              </Col>
              <Col
                md={4}
                className={`form-group pr-2 ${ehExame ? '' : 'd-none'}`}
              >
                <Input
                  name="ProCodigoAlvaro"
                  label="Código Alvaro"
                  maxLength={20}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4} className="form-group pr-2">
                <Input
                  name="ProDuracao"
                  label="Duração Padrão"
                  type="number"
                  max={120}
                  min={5}
                  step={5}
                  maxLength={3}
                />
              </Col>
              <Col md={4} className="form-group pr-2">
                <Input
                  name="ProRetorno"
                  label="Dias para Retorno"
                  maxLength={3}
                />
              </Col>
              <Col md={4} className="form-group pr-2">
                <InputMoney name="ProValor" label="Valor Particular" />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <InputMoney name="ProValorPlano" label="Valor Cartão Saúde" />
              </Col>

              <Col md={3} className="form-group pr-2">
                <Input
                  name="ProCarencia"
                  label="Carência Parcela"
                  type="number"
                  max={11}
                  min={0}
                  maxLength={2}
                />
              </Col>
              <Col md={3} className="form-group pr-2">
                <InputMoney name="ProValorPlano2" label="Valor Fora Carência" />
              </Col>
              <Col md={3} className="form-group pr-2">
                <Input
                  name="ProLimite"
                  label="Dias Px. Marcação"
                  type="number"
                  max={360}
                  min={0}
                  maxLength={3}
                />
              </Col>
            </Row>
            <Row>
              {CliSaoPaulo && (
                <Col md={3}>
                  <InputMoney
                    name="ProValorPlanoEmpresarial"
                    label="Valor Empresarial"
                  />
                </Col>
              )}

              <Col md={3} className="form-group pr-2">
                <Toggle nome="ProAtivo" label="Ativo" isDisabled={false} />
              </Col>
              <Col md={3} className="form-group pr-2 d-none">
                <Toggle
                  nome="ProFavorito"
                  label="Favorito"
                  isDisabled={false}
                  className="d-none"
                />
              </Col>
              {user.UsuCodigo === 1 && clinica.CliTelemedicina && (
                <>
                  <Col
                    md={3}
                    className="form-group pr-2"
                    style={{ display: 'grid', textAlign: 'center' }}
                  >
                    <Toggle
                      nome="ProOnline"
                      label="Site"
                      isDisabled={false}
                      classSpam={{
                        paddingRight: '10px',
                        marginBottom: '7px',
                        fontWeight: 'bold',
                      }}
                    />
                  </Col>
                  <Col
                    md={3}
                    className="form-group pr-2"
                    style={{ display: 'grid', textAlign: 'center' }}
                  >
                    <Toggle
                      nome="ProTelemedicina"
                      label="Atende Telemedicina"
                      isDisabled={false}
                      classSpam={{
                        paddingRight: '10px',
                        marginBottom: '7px',
                        fontWeight: 'bold',
                      }}
                    />
                  </Col>
                </>
              )}
            </Row>
            <Row className="align-items-center border-top p-1">
              <Col md="12">
                <div className="light-grey text-left pt-3">
                  <>
                    <Button
                      type="submit"
                      variant="success"
                      className="mt-2"
                      disabled={loading}
                    >
                      {loading ? 'Salvando...' : 'Salvar dados'}
                    </Button>
                  </>
                </div>
              </Col>
            </Row>
          </Form>
          {proCodigo && clinica.CliAtendeConvenio && (
            <>
              {showAddValor && (
                <AddValor
                  ProCodigo={proCodigo}
                  Adicionou={handleSalvouNovoValor}
                />
              )}
              <Row
                noGutters
                className="bg-light py-2 mt-2 border-top border-bottom"
                style={{ fontSize: 'Small' }}
              >
                <Col sm={4} md={4} lg={6}>
                  <b>Convênio</b>
                </Col>
                <Col sm={3} md={3} lg={2}>
                  <b>Valor</b>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <b>Retorno</b>
                </Col>
                <Col className="pl-2" sm={2} md={2} lg={1}>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-primary"
                    className="py-0 px-2"
                    onClick={() => setShowAddValor(true)}
                  >
                    <FiPlusCircle size={17} />
                  </Button>
                </Col>
                <Col md={1} lg={1}>
                  -
                </Col>
              </Row>

              {clinica.CliAtendeConvenio &&
                procedimento &&
                procedimentoValor &&
                procedimentoValor.map(tabela => (
                  <LinhaValor
                    key={`${tabela.ConvCodigo}-${tabela.ProCodigo}-${tabela.valor}`}
                    valorConvenio={tabela}
                    handleDeletou={
                      dados => handleDeletouConvenioValor(dados)
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  />
                ))}
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProcedimentoCadastroPagina;
